import { VStack } from 'tio-ui/components/layout';

<template>
  <VStack>{{outlet}}</VStack>
</template>
